import type { TableSortDirection } from '../DataTable.types'
import { TABLE_ORDER_PARAM, TABLE_SORT_PARAM } from '../DataTable.constants'

export function buildTableSortSearchParams(
  current: URLSearchParams,
  columnKey: string,
  direction: TableSortDirection
): URLSearchParams {
  const params = new URLSearchParams(current)
  params.set(TABLE_SORT_PARAM, columnKey)
  params.set(TABLE_ORDER_PARAM, direction)
  return params
}
